import React, { useContext, useState } from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import useClient from '@hooks/useClient';
import CompanySharedLinkModal from './CompanySharedLinkModal';

const CompanyNavButtons: React.FunctionComponent = () => {
  const [open, setOpen] = useState(false);
  const {
    clientState: { accessToken }
  } = useClient();
  const isAuth = !!accessToken;
  const { buttonGroupContainer, companySideButton } = useStyles({ isAuth });

  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) {
    return null;
  }

  return (
    <Box className={buttonGroupContainer}>
      {open && (
        <CompanySharedLinkModal open={open} onClose={() => setOpen(false)} />
      )}
      <CustomizedButton
        className={companySideButton}
        fullWidth
        variant={'contained'}
        color={'primary'}
        onClick={() => setOpen(true)}
      >
        <CustomizedTypography color={'inherit'} variant={'body2'}>
          공유하기
        </CustomizedTypography>
      </CustomizedButton>
    </Box>
  );
};

export default CompanyNavButtons;

const useStyles = makeStyles<Theme, { isAuth: boolean }>((theme) => ({
  buttonGroupContainer: {
    display: 'flex',
    gap: '8px',
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  companySideButton: {
    minWidth: '96px !important',
    [theme.breakpoints.down('md')]: {
      height: 40,
      width: '100%'
    }
  }
}));
